// src/routes/ProtectedRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import NotFound from "../pages/NotFound";
import { jwtDecode } from "jwt-decode";

export const ProtectedRoute = ({ allowedRoles }) => {
    const { token, rol, isAuthReady } = useAuth();

    if (!isAuthReady) return null; // espera hidratación

    const effectiveToken = token || localStorage.getItem("token");
    const effectiveRolStr = (rol ?? localStorage.getItem("rol"));
    const roleStr = effectiveRolStr != null ? String(effectiveRolStr) : null;

    const isExpired = (t) => {
        try { const { exp } = jwtDecode(t); return !exp || exp < Date.now() / 1000; }
        catch { return true; }
    };

    if (!effectiveToken || isExpired(effectiveToken)) {
        localStorage.clear();
        return <Navigate to="/evaluation-system-verify/login" replace />;
    }

    if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
        const allowed = allowedRoles.map(String);
        if (roleStr == null) return null;           // no bloquees mientras se resuelve rol
        if (!allowed.includes(roleStr)) return <NotFound />;
    }

    return <Outlet />;
};
